import $ from "jquery";
import Lights from 'shared/components/lights';
import { showNavbar, hideNavbar, removeBodyScroll, restoreBodyScroll } from './ReportIssueUtils';

export default class ReportContentIssue {
  constructor({$element: $element}){
    this.$element = $element;
    this.lights = Lights;

    this.selector = {
      form: `#report-abuse-${ $element[0].dataset.reportId }`,
      submitButton: '.report-abuse__submit'
    }

    this.ui = {};

    Object.keys(this.selector).forEach((key) => {
      this.ui[key] = $(this.selector[key]);
    });
  }

  init() {
    this.bindFormSubmitClick();
  }

  bindFormSubmitClick(){
    this.ui.submitButton.on('click', () => {
      this.hideForm();
    });
  }

  showForm() {
    removeBodyScroll();
    this.ui.form.show();
    this.lights.off.bind(this)();
    hideNavbar();
  }

  hideForm() {
    restoreBodyScroll();
    this.ui.form.hide();
    this.lights.on.bind(this)();
    showNavbar();
  }

  close(){
    this.hideForm();
  }
}